import {
  SET_TOTAL,
  NOTIFICATION_TOTAL_REFRESH,
  INIT_FORWARD_LIST,
  NOTIFICATION_SEEN_AND_REFRESH,
} from '../../constant';

const SetNotificationTotal = (total) => ({
  type: SET_TOTAL,
  data: total,
});

const RefreshNotificationTotal = () => ({
  type: NOTIFICATION_TOTAL_REFRESH,
});

const InitForwardList = (data) => ({
  type: INIT_FORWARD_LIST,
  data,
});

const seenAndRefreshNotificationTotal = () => ({ type: NOTIFICATION_SEEN_AND_REFRESH });

export { SetNotificationTotal, RefreshNotificationTotal, InitForwardList, seenAndRefreshNotificationTotal };
